import { Component } from "@angular/core";
import { XOArrayField } from './xo-array-field.component';

@Component({
    selector: "xo-field-array-longstring",
    templateUrl: "./xo-field-array-longstring.component.html"
})
export class XOArrayFieldLongString extends XOArrayField {
}
